import { Box, IconButton, styled, Typography } from '@mui/material';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { DynamicTooltipChip } from 'src/components/dynamicTooltipChip/DynamicTooltipChip';

import { StyledTabProps } from './DetailComponentPage.interface';

export const ComponentEditContainer = styled(Box)`
  display: flex;
  flex: 1;
  height: 100vh;
  flex-direction: row;
  padding: 0 !important;
`;

export const ComponentEditSideMenuContainer = styled(Box)`
  position: relative;
  width: 25rem;
`;

export const HeaderContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1.25rem 0.875rem 0 0.875rem;
`;

export const ComponentEditContentContainer = styled(Box)(
  ({ theme }) => `
    display: flex;
    flex: 1;
    flex-direction: column;
    border-left: 0.0625rem solid ${theme.palette.secondary.light};
    overflow: auto;
  `,
);

export const ContentContainer = styled(Box)`
  margin-top: 0.625rem;
  width: 70vw;
  height: 80vh;
  flex-shrink: 0;
`;

export const CardMediaContainer = styled(Box)`
  position: relative;
  margin-right: 15px;
  .MuiButtonBase-root {
    visibility: visible;
  }
`;

export const ComponentMenuIcon = styled(IconButton)(
  ({ theme }) => `
    visibility: hidden;
    transition: all 0.3s ease;
    border-radius: 0.25rem;
    background-color: ${theme.palette.primary.contrastText};
    box-shadow: 0rem 0.0625rem 0.25rem rgba(0, 0, 0, 0.25);
  `,
);

export const BoxStyle = styled(Box)`
  padding: 1.25rem;
`;

export const AntTabs = styled(Tabs)(
  ({ theme }) => `
  border-Bottom: 0.0625rem solid ${theme.palette.primary.light};
  font-weight: 500;
  font-size: 1rem;
  font-family: Roboto;
  margin-Top: 0.9375rem;
  width: auto;
  & .MuiTabs-flexContainer {
    flex-direction: row;
  }
  `,
);

export const AntTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(
  ({ theme }) => `
    text-transform: none;
    font-family: 'Roboto';
    &:hover {
      color: ${theme.palette.primary.main};
    }
    &.Mui-selected {
      color: ${theme.palette.secondary.dark};
    },
    font-weight: 500;
  `,
);

export const ComponentInfoTitle = styled(Typography)(
  ({ theme }) => `
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.125rem;
  display: flex;
  align-items: center;
  width: 13.25rem;
  height: 1.1875rem;
  color:${theme.palette.secondary.dark};
`,
);

export const ComponentInfoText = styled(Typography)(
  ({ theme }) => `
  font-weight: 300;
  font-size: 1rem;
  font-family: 'Roboto';
  font-style: normal;
  line-height: 1.75rem;
  color:${theme.palette.secondary.dark};
  padding-bottom: 2.5rem;
`,
);

export const ChipContainer = styled(Typography)`
  display: inline-flex;
  align-items: center;
`;

export const ComponentChipStyle = styled(Typography)`
  width: auto;
  height: 1.1875rem;
  line-height: 1rem;
  align-items: center;
  padding-bottom: 2.5rem;
  margin-right: 0.5rem;
`;

export const ComponentText = styled(Typography)`
  padding-right: 20px;
`;

export const StyledChipContainer = styled(Box)`
  margin: 5px 5px 5px 0;
  display: inline-block;
`;

export const StyledDynamicTooltipChip = styled(DynamicTooltipChip)`
  max-width: 272px;
`;
